const _ind_a = {
    en: [
        { code:"01" , name:"computer software" },
        { code:"02" , name:"Electronics/semiconductor / integrated circuits" },
        { code:"03" , name:"finance / investment / securities" },
        { code:"04" , name:"trade / Import & export" },
        { code:"05" , name:"fast moving consumer goods (food, beverages, cosmetics)" },
        { code:"06" , name:"apparel / Textile / leather" },
        { code:"07" , name:"professional services (consulting, human resources)" },
        { code:"08" , name:"pharmaceuticals / bioengineering" },
        { code:"09" , name:"architecture and engineering" },
        { code:"37" , name:"computer hardware" },
        { code:"38" , name:"computer services (systems, data services, maintenance)" },
        { code:"31" , name:"communications/telecommunications/ networking equipment" },
        { code:"39" , name:"communications/telecom operators,value-added services" },
        { code:"32" , name:"Internet / e-commerce" },
        { code:"40" , name:"online games" },
        { code:"35" , name:"instrumentation / industrial automation" },
        { code:"41" , name:"accounting / auditing" },
        { code:"42" , name:"bank" },
        { code:"43" , name:"insurance" },
        { code:"22" , name:"wholesale / retail" },
        { code:"44" , name:"furniture / appliances / crafts / toys" },
        { code:"45" , name:"office supplies and equipment" },
        { code:"14" , name:"machinery / equipment / heavy industry" },
        { code:"33" , name:"auto parts" },
        { code:"46" , name:"medical / nursing / health / hygiene" },
        { code:"47" , name:"medical devices / devices" },
        { code:"12" , name:"Advertisement" },
        { code:"48" , name:"PR / marketing / exhibition" },
        { code:"49" , name:"video / media / art" },
        { code:"13" , name:"text media / publishing" },
        { code:"15" , name:"printing / packaging / paper" },
        { code:"26" , name:"real estate development" },
        { code:"50" , name:"home / Interior Design / decoration" },
        { code:"51" , name:"property management / business center" },
        { code:"34" , name:"intermediary services" },
        { code:"52" , name:"detection, authentication" },
        { code:"18" , name:"law" },
        { code:"23" , name:"education / training" },
        { code:"24" , name:"academic / research" },
        { code:"11" , name:"catering industry" },
        { code:"53" , name:"hotel / tourism" },
        { code:"17" , name:"entertainment / leisure / sports" },
        { code:"54" , name:"beauty care" },
        { code:"27" , name:"life services" },
        { code:"21" , name:"traffic / transportation / logistics" },
        { code:"55" , name:"aerospace" },
        { code:"19" , name:"oil / chemical / mineral / geology" },
        { code:"16" , name:"mining / smelting" },
        { code:"36" , name:"Power & water" },
        { code:"56" , name:"raw materials and processing" },
        { code:"28" , name:"government" },
        { code:"57" , name:"non profit organization" },
        { code:"20" , name:"environmental protection" },
        { code:"29" , name:"agriculture / fisheries / forestry" },
        { code:"58" , name:"diversified business group" },
        { code:"30" , name:"other industries" }
    ],
    zh: [
        { code:"01" , name:"计算机软件" },
        { code:"37" , name:"计算机硬件" },
        { code:"38" , name:"计算机服务(系统、数据服务，维修)" },
        { code:"31" , name:"通信/电信/网络设备" },
        { code:"39" , name:"通信/电信运营、增值服务" },
        { code:"32" , name:"互联网/电子商务" },
        { code:"40" , name:"网络游戏" },
        { code:"02" , name:"电子技术/半导体/集成电路" },
        { code:"35" , name:"仪器仪表/工业自动化" },
        { code:"41" , name:"会计/审计" },
        { code:"03" , name:"金融/投资/证券" },
        { code:"42" , name:"银行" },
        { code:"43" , name:"保险" },
        { code:"04" , name:"贸易/进出口" },
        { code:"22" , name:"批发/零售" },
        { code:"05" , name:"快速消费品(食品, 饮料, 化妆品)" },
        { code:"06" , name:"服装/纺织/皮革" },
        { code:"44" , name:"家具/家电/工艺品/玩具" },
        { code:"45" , name:"办公用品及设备" },
        { code:"14" , name:"机械/设备/重工" },
        { code:"33" , name:"汽车及零配件" },
        { code:"08" , name:"制药/生物工程" },
        { code:"46" , name:"医疗/护理/保健/卫生" },
        { code:"47" , name:"医疗设备/器械" },
        { code:"12" , name:"广告" },
        { code:"48" , name:"公关/市场推广/会展" },
        { code:"49" , name:"影视/媒体/艺术" },
        { code:"13" , name:"文字媒体/出版" },
        { code:"15" , name:"印刷/包装/造纸" },
        { code:"26" , name:"房地产开发" },
        { code:"09" , name:"建筑与工程" },
        { code:"50" , name:"家居/室内设计/装潢" },
        { code:"51" , name:"物业管理/商业中心" },
        { code:"34" , name:"中介服务" },
        { code:"07" , name:"专业服务(咨询，人力资源)" },
        { code:"52" , name:"检测，认证" },
        { code:"18" , name:"法律" },
        { code:"23" , name:"教育/培训" },
        { code:"24" , name:"学术/科研" },
        { code:"11" , name:"餐饮业" },
        { code:"53" , name:"酒店/旅游" },
        { code:"17" , name:"娱乐/休闲/体育" },
        { code:"54" , name:"美容/保健" },
        { code:"27" , name:"生活服务" },
        { code:"21" , name:"交通/运输/物流" },
        { code:"55" , name:"航天/航空" },
        { code:"19" , name:"石油/化工/矿产/地质" },
        { code:"16" , name:"采掘业/冶炼" },
        { code:"36" , name:"电力/水利" },
        { code:"56" , name:"原材料和加工" },
        { code:"28" , name:"政府" },
        { code:"57" , name:"非盈利机构" },
        { code:"20" , name:"环保" },
        { code:"29" , name:"农业/渔业/林业" },
        { code:"58" , name:"多元化业务集团公司" },
        { code:"30" , name:"其他行业" }
    ]
};

export default _ind_a;


// WEBPACK FOOTER //
// ./src/assets/js/industry.js